



















































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import moment from 'moment';
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBoxScoreStamp.vue";
import { BModal, BCarousel, BPopover } from 'bootstrap-vue';
import { Sheet, SheetField, SheetActivity, FieldActivity, ParamFieldActivity, SaitenModeEnum, CorrectStateEnum, SortKindEnum, ScoreStamp, Point } from "../../modules/teacher/SaitenInputScoreStamp";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  inputScale: number
  fieldPadding: number
  fieldMargin: number
  windowHeight: number
  SaitenModeEnum: Readonly<{None: number; KeyInput: number; SeitouClick: number; GotouClick: number; TokutenClick: number; 
                            FreeLine: number; StraightLine: number; BracesStart: number; BracesEnd: number; Number: number; Eraser: number; Trash: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number; ScoreStamp: number;}>
  SortKindEnum: Readonly<{No: number; CorrectState: number; FileSize: number}>
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  saitenMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  base64CorrectImage: string
  tensakuText: string
  tensakuFontSize: number
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isShortcutKeyEnable: boolean
  isUpdateConfirmed: boolean
  tensakuNumberOptions: any[]
  fontSizeOptions: any[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  carouselPageIdx: number
  modalIdx: number
  timer: any
  errors: string[]
  scoring_type_name: string
  isShowContextMenu: boolean
  pagePos: Point
  stampPos: Point
  contextButtonWidth: number
  contextButtonHeight: number
  contextScoreRows: any[]
  modeAreaLeft: number
  modeAreaTop: number
  modeAreaWidth: number
  keyCode: string
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
  },
  setup(props, context){

    const saitenBoxRef = ref([]);
    const modalCorrectImageRef = ref<InstanceType<typeof BModal>>();
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const modalPreviewImageRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      inputScale: 1,
      fieldPadding: 8,
      fieldMargin: 5,
      windowHeight: 0,
      SaitenModeEnum: SaitenModeEnum,
      CorrectStateEnum: CorrectStateEnum,
      SortKindEnum: SortKindEnum,
      SheetTypeEnum: Common.SheetTypeEnum,
      saitenMode: SaitenModeEnum.None,
      sortKind: SortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      base64CorrectImage: "",
      tensakuText: "1",
      tensakuFontSize: 30,
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isShortcutKeyEnable: false,
      tensakuNumberOptions: new Array<object>(),
      fontSizeOptions: new Array<object>(),
      pcHelpFields: [
        { key: "Oキー", img: require("@/assets/images/keyboard_O.png"), description: "正答○" },
        { key: "Xキー", img: require("@/assets/images/keyboard_X.png"), description: "誤答✕" },
        { key: "1-9キー", img: require("@/assets/images/keyboard_1.png"), description: "スタンプ得点の得点を編集" },
        { key: "＋キー", img: require("@/assets/images/keyboard_Plus.png"), description: "現在選択中のスタンプ得点からプラス1点に切り替え" },
        { key: "−キー", img: require("@/assets/images/keyboard_Minus.png"), description: "現在選択中のスタンプ得点からマイナス1点に切り替え" },
        { key: "Sキー + クリック", img: require("@/assets/images/keyboard_S.png"), description: "クリックした場所に得点スタンプを出力" },
        { key: "スタンプ選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "選択中の得点スタンプを削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Wキー", img: require("@/assets/images/keyboard_W.png"), description: "模範解答画像を表示" },
        { key: "エンターキー", img: require("@/assets/images/keyboard_Enter.png"), description: "次の生徒の切出し画像へ選択を変更" },
        { key: "右矢印キー", img: require("@/assets/images/keyboard_Arrow_Right.png"), description: "次の生徒の切出し画像へ選択を変更" },
        { key: "左矢印キー", img: require("@/assets/images/keyboard_Arrow_Left.png"), description: "前の生徒の切出し画像へ選択を変更" },
      ],
      tabletHelpFields: [
        { key: "画像上を長押し", img: null, description: "○×得点スタンプを選択するメニューが表示されます。<br>・○ → 次の画像へ遷移します。<br>・× → 次の画像へ遷移します。<br>・得点 → 長押しした箇所に得点スタンプが表示されます。" },
        { key: "得点スタンプを長押し", img: null, description: "得点スタンプを削除します。" },
        { key: "", img: require("@/assets/images/keyboard_Arrow_Left_Right.png"), description: "次の画像、前の画像に遷移します。" },
        { key: "", img: require("@/assets/images/keyboard_ModeArea.png"), description: "メニューボタンがON（緑色）になっている場合は、<font style='color:red'>長押し操作が反映されません。</font><br>ON（緑色）のアイコンを押すと、OFF（グレー）に戻ります。" },
      ],
      carouselPageIdx: 0,
      modalIdx: 0,
      timer: null,
      errors: [],
      scoring_type_name: null,
      isShowContextMenu: false,
      pagePos: new Point(0, 0),
      stampPos: new Point(0, 0),
      contextButtonWidth: 40,
      contextButtonHeight: 30,
      contextScoreRows: [],
      modeAreaLeft: 0,
      modeAreaTop: 0,
      modeAreaWidth: context.root.$store.state.isMobile ? 260 : 350,
      keyCode: "",
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      
    });

    /************************************************************
     * コンテキストメニューのボタンStyle
     ************************************************************/

    const contextButtonStyle = computed((): any => {
      return {width: `${state.contextButtonWidth}px`, height: `${state.contextButtonHeight}px`}
    });

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * コンテキストメニューのStyle
     ************************************************************/

    const contextAreaStyle = computed((): any => {
      const padding = 18;
      const rowCnt = state.contextScoreRows.length + 1;
      let colCnt = state.contextScoreRows.map((x: number[]) => x.length).reduce((a,b)=>Math.max(a,b));
      // 部分点数が1の場合、○×ボタンがあるので2列とする
      if(colCnt == 1){
        colCnt = 2;
      }
      return {
        left: `${state.pagePos.x - 10}px`,
        top: `${state.pagePos.y - (state.contextButtonHeight * rowCnt + padding * 2) + 10}px`,
        width: `${state.contextButtonWidth * colCnt + padding * 2}px`,
        height: `${state.contextButtonHeight * rowCnt + padding * 2}px`,
        padding: `${padding}px`,
      }
    });

    /************************************************************
     * モーダル表示対象の答案画像
     ************************************************************/

    const base64PreviewImages = computed((): any => {
      return state.fieldActivities[state.modalIdx].base64PreviewImages;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      const windowHeight = window.innerHeight;
      const imageArea = document.getElementById("image-area");
      const tableArea = document.getElementById("table-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        imageArea.style.height = (windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5) + "px";
      }

      // 生徒一覧表示エリアの高さを画面サイズに合わせる
      if(tableArea != null && footerArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5) + "px";
      }

      // 添削ボタンエリアの座標リセット
      state.modeAreaTop = (imageArea.offsetTop + 10);
      state.modeAreaLeft =  10;
    };

    /************************************************************
     * 倍率を加味した切り出し画像のWidth
     ************************************************************/

    const fieldImageWidth = computed((): any => {
      return state.currentSheetField.baseWidth * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのWidth
     ************************************************************/

    const fieldWrapWidth = computed((): any => {
      return fieldImageWidth.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 倍率を加味した切り出し画像のHeight
     ************************************************************/

    const fieldImageHeight = computed((): any => {
      return state.currentSheetField.baseHeight * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのHeight
     ************************************************************/

    const fieldWrapHeight = computed((): any => {
      return fieldImageHeight.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 切り出し画像エリア内に画像が全て収まるように整形
     ************************************************************/

    const fitToImageArea = () => {
      const imageArea = document.getElementById("image-area");
      const scaleW = (imageArea.clientWidth - (state.fieldMargin * 2) - (state.fieldPadding * 2)) / (state.currentSheetField.baseWidth);
      const scaleH = (imageArea.clientHeight - (state.fieldMargin * 2) - (state.fieldPadding * 2)) / (state.currentSheetField.baseHeight);
      state.inputScale = Math.round((scaleW > scaleH ? scaleH : scaleW) * 100);
    }

    /************************************************************
     * 拡大
     ************************************************************/

    const scaleUp = () => {
      blur();
      state.inputScale += 5;
    };

    /************************************************************
     * 縮小
     ************************************************************/

    const scaleDown = () => {
      blur();
      if(state.inputScale > 10){
        state.inputScale -= 5;
      }
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const showModalCorrectImage = () => {
      blur();
      modalCorrectImageRef.value.show();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (idx: number) => {
      blur();
      state.modalIdx = idx;

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      state.carouselPageIdx = 0;
      modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async () => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const student_id = state.fieldActivities[state.modalIdx].sheetActivity.student_id;
      await http.get(`/api/saiten_input_score_stamp/download_preview_image/${state.sheet_id}/${student_id}/${state.carouselPageIdx + 1}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          state.fieldActivities[state.modalIdx].base64PreviewImages.push(x);
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = async () => {
      // carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.currentSheet.page_count - 1;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = async () => {
      // carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.currentSheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalStudent = async () => {
      
      if(state.modalIdx > 0){
        state.modalIdx--;
      }else{
        state.modalIdx = state.fieldActivities.length - 1;
      }

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalStudent = async () => {
      if(state.modalIdx + 1 < state.fieldActivities.length){
        state.modalIdx++;
      }else{
        state.modalIdx = 0;
      }
      
      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      // modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number) => {
      blur();
      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if(sortKind == state.SortKindEnum.No){
        state.fieldActivities.sort((a, b) => a.sheetActivity.student_id - b.sheetActivity.student_id);
      }else if(sortKind == state.SortKindEnum.CorrectState){
        state.fieldActivities.sort((a, b) => {
          if(a.score != b.score){
            return (a.score - b.score) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }else{
        state.fieldActivities.sort((a, b) => {
          if(a.base64Image.length != b.base64Image.length){
            return (a.base64Image.length - b.base64Image.length) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }
    };

    /************************************************************
     * 添削モードエリアドラッグ系処理
     ************************************************************/

    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 8;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeSaitenMode = (saitenMode: number) => {
      blur();
      if(state.saitenMode == saitenMode){
        state.saitenMode = state.SaitenModeEnum.None;
      }else{
        state.saitenMode = saitenMode;
      }
    }

    /************************************************************
     * 採点BOXからのemitによる採点モード切り替え
     ************************************************************/

    const changeSaitenModeBySaitenBox = (saitenMode: number) => {
      state.saitenMode = saitenMode;
    }

    /************************************************************
     * 正答or誤答採点
     ************************************************************/

    const updateCorrectState = (correct_state: number, score: number) => {

      state.isShowContextMenu = false;

      if(!setCorrect(correct_state, score)){
        return;
      }

      state.fieldActivities[state.selectedIdx].scoreStamps = [];

      if(state.selectedIdx + 1 == state.fieldActivities.length){
        if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
          setTimeout(() => {
            // 次の設問
            if(state.next_sheet_field != null){          
              toNextField();
            }else if(window.confirm("最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
              sendSaitenData(null, null);
            }
          }, 100);
        }
      }else{
        state.selectedIdx++;
      }
    }

    /************************************************************
     * 表示対象の切り出し画像切り替え
     ************************************************************/

    const changeSelectedIdx = (idx: number) => {
      state.selectedIdx = idx;
    }

    /************************************************************
     * 次の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxUp = () => {
      if(state.selectedIdx + 1 < state.fieldActivities.length){
        state.selectedIdx++;
      }
    }

    /************************************************************
     * 前の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxDown = () => {
      if(state.selectedIdx - 1 >= 0){
        state.selectedIdx--;
      }
    }

    /************************************************************
     * コンテキストメニュー表示
     ************************************************************/

    const showContextMenu = (pagePos: Point, stampPos: Point) => {
      state.pagePos = pagePos;
      state.stampPos = stampPos;
      state.isShowContextMenu = true;
    }

    /************************************************************
     * コンテキストメニュー非表示切り替え
     ************************************************************/

    const hideContextMenu = () => {
      state.isShowContextMenu = false;
    }

    const contextMenuMouseDown = (e: MouseEvent) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyDown = (e:KeyboardEvent) => {
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {

      state.keyCode = "";

      if(e.key == "e" || e.key == "d"){
        // 現在描画中のcanvasを保持
        saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
          if(x.idx == state.selectedIdx){
            x.resetDrawingByKeyUp();
          }
        });
      }
      
      // API通信中は処理しない
      if(!state.isShortcutKeyEnable){
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      blur();
      e.preventDefault();
      if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key)){
        // 部分点プルダウン切り替え
        let score = state.selectedScore < 0 ? -(Number(e.key)) : Number(e.key);
        if(state.scoreOptions.map((x: any) => x.value).includes(score)){
          state.selectedScore = score;
          state.saitenMode = state.SaitenModeEnum.TokutenClick;
        }
      }else if(e.key == ";" || e.key == "+"){
        // 部分点プラス
        if(state.selectedScore < state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == -1 ? 1 : state.selectedScore + 1;
        }
      }else if(e.key == "-"){
        // 部分点マイナス
        if(state.selectedScore > -state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == 1 ? -1 : state.selectedScore - 1;
        }
      }else if(e.key == "x"){
        // 誤答採点
        updateCorrectState(CorrectStateEnum.Gotou, 0);
      }else if(e.key == "o"){
        // 誤答採点
        updateCorrectState(CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(["Enter", "ArrowLeft", "ArrowRight"].indexOf(e.key) != -1){
        let nextIdx = state.selectedIdx;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の切り出しへ
          nextIdx = state.selectedIdx - 1;
          if(nextIdx < 0){
            return;
          }
        }else if(e.key == "ArrowRight" || e.key == "Enter"){
          // 最終切り出しでエンターor右矢印キーの場合、次の設問へ移動
          // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
          if(e.key == "Enter" && modalCorrectImageRef.value.$data.isShow){
            modalCorrectImageRef.value.hide();
          }else if(e.key == "Enter" && modalAddtionRef.value.$data.isShow){
            modalAddtionRef.value.hide();
          }else if(state.selectedIdx + 1 == state.fieldActivities.length){
            
            // 最終切り出しでEnter or 右矢印は次の設問 又は 次の教室へ
            if(state.next_sheet_field != null){          
              toNextField();
            }else if(window.confirm("最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
              sendSaitenData(null, null);
            }
          }else{
            // 右矢印 次の切り出しへ
            nextIdx =  state.selectedIdx + 1;
          }
        }
        state.selectedIdx = nextIdx;

      }else if(e.key == "w"){
        // Wキー 模範解答モーダル表示
        modalCorrectImageRef.value.show();
      }else if(e.key == "Backspace"){
        state.fieldActivities[state.selectedIdx].scoreStamps.filter(x => x.isActive).forEach(x => {
          const idx = state.fieldActivities[state.selectedIdx].scoreStamps.indexOf(x);
          deleteScoreStamp(state.selectedIdx, idx);
        });
        
      }
    };

    /************************************************************
     * 採点内容変更
     ************************************************************/

    const setCorrect = (correctState: number, score: number) => {

      const fieldActivity = state.fieldActivities[state.selectedIdx];
      fieldActivity.correct_state = correctState;
      fieldActivity.score = score;

      state.fieldActivities[state.selectedIdx].is_correct_changed = fieldActivity.score != fieldActivity.score_cache || isStampChanged(fieldActivity) ? true : fieldActivity.is_correct_changed_cache;

      return true;
    }

    /************************************************************
     * 得点スタンプ編集有無判定
     ************************************************************/

    const isStampChanged = (fieldActivity: FieldActivity) => {
      return JSON.stringify(fieldActivity.scoreStamps) != JSON.stringify(fieldActivity.scoreStampCaches);
    }

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrect = async () => {
      blur();

      if(!window.confirm("画面に表示されている採点内容のデータを削除します。よろしいですか？")){
        return;
      }
      
      if(state.currentSheet.result_published && !window.confirm("成績が既に公開されています。非公開になりますが、本当によろしいですか？")){
        return;
      }

      // パラメータ用FieldActivities
      const paramFieldActivities = new Array<ParamFieldActivity>();
      state.fieldActivities.forEach(x => {
        paramFieldActivities.push(new ParamFieldActivity(x));
      });

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/saiten_input_score_stamp/clear_correct/${state.sheet_field_id}`, {field_activities: JSON.stringify(paramFieldActivities)}).then(response => {
        alert(`採点内容のクリアに成功しました。`);
        window.location.reload();
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = () => {
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("採点内容を保存して採点一覧に戻ります。よろしいですか？")){
        return;
      }

      sendSaitenData(null, null);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = () => {
      blur();
      if(!confirmUncompletedField() || !window.confirm("前の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.prev_sheet_field);
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("次の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.next_sheet_field);
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("次の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field);
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("前の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field);
    };

    /************************************************************
     * 未採点有無の確認
     ************************************************************/

    const confirmUncompletedField = () => {
      const isExistsUncompletedField = state.fieldActivities.filter(x => x.correct_state == null).length > 0;
      if(isExistsUncompletedField && !window.confirm("未採点があります。よろしいですか？")){
        return false;
      }else{
        return true;
      }
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!window.confirm("メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/saiten_input_score_stamp/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}_tensaku.png`, x.base64Canvas, {base64: true});
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
        const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache || isStampChanged(x)).map(x => x.id);
        const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("scoring_type", `${state.currentSheetField.scoring_type}`);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));

        await http.patch(`/api/saiten_input_score_stamp/${state.sheet_id}`, fd).then(async response => {
          
          if(next_sheet_id != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
              context.root.$nextTick(() => {
                initialize();
              });
            }
          }else{
            // 採点一覧へ戻る
            context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
          }
        })
        .catch(error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 排他制御解除して別設問へ移動するAPI
     ************************************************************/
    const changeFieldWithResetLastScored = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      await http.post(`/api/saiten_input_score_stamp/reset_last_scored/${state.sheet_field_id}`).then(response => {
        if(next_sheet_id != null){
          if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
            // 正誤採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(err => {});
          }else{
            // 得点スタンプ採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(err => {});
            context.root.$nextTick(() => {
              initialize();
            });
          }
        }else{
          // 採点一覧へ戻る
          context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
        }
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      let browsableSheetErrMessage = null;
      await http.get(`/api/saiten_input_score_stamp/check_saiten_lock/${state.sheet_field_id}`).then(response => {
        confirmMessage = response.data.confirm_message;
        browsableSheetErrMessage = response.data.browse_lock_err_message;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!window.confirm(confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      await http.get(`/api/saiten_input_score_stamp?sheet_id=${state.sheet_id}&sheet_field_id=${state.sheet_field_id}`).then(response => {

        browsableSheetErrMessage = response.data.browse_lock_err_message;
        if (browsableSheetErrMessage != null) {
          return;
        }

        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any) => new FieldActivity(x, response.data.sheet_activities, response.data.students, response.data.base64_image_hash_array, response.data.base64_canvas_hash_array, state.currentSheet.page_count, response.data.score_stamps));
        state.base64CorrectImage = response.data.base64_correct_image;
        state.next_room_sheet_id = response.data.next_room_sheet_id;
        state.next_room_sheet_field =  response.data.next_room_sheet_field ? new SheetField(response.data.next_room_sheet_field, response.data.buff_size) : null;
        state.prev_room_sheet_id = response.data.prev_room_sheet_id;
        state.prev_room_sheet_field = response.data.prev_room_sheet_field ? new SheetField(response.data.prev_room_sheet_field, response.data.buff_size) : null;
        state.prev_sheet_field = response.data.prev_sheet_field ? new SheetField(response.data.prev_sheet_field, response.data.buff_size) : null;
        state.next_sheet_field = response.data.next_sheet_field ? new SheetField(response.data.next_sheet_field, response.data.buff_size) : null;
        state.selectedIdx = 0;
        state.processingTime = 0;
        state.carouselPageIdx = state.currentSheetField.page -1;
        state.scoring_type_name = Common.GetScoringTypeNameByCode(state.currentSheetField.scoring_type);

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = -state.currentSheetField.allot; i <= state.currentSheetField.allot; i++){
          if(i != 0){
            state.scoreOptions.push({value: i, text: `${i}点`});
          }
        }

        // 部分点プルダウン初期選択値設定
        state.selectedScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 1 : -1;

        // コンテキストメニューの部分点ボタンバインド用配列生成
        const contextScoreRows = [];
        let contextScoreCols = [];
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(-i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        state.contextScoreRows = contextScoreRows;

        // 数字入力プルダウン生成
        state.tensakuNumberOptions = new Array<any>();
        for(let i = -100; i < 101; i++){
          state.tensakuNumberOptions.push({value: i, text: `${i}`});
        }

        // フォントサイズプルダウン生成
        state.fontSizeOptions = new Array<any>();
        for(let i = 5; i < 101; i++){
          state.fontSizeOptions.push({value: i, text: i});
        }
        
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      if(!state.isWindowEventAdded){
        window.addEventListener("keyup", keyUp);
        window.addEventListener("keydown", keyDown);
        window.addEventListener("resize", adjustLayout);
        state.isWindowEventAdded = true;
      }
      adjustLayout();
      fitToImageArea();
      state.processingTime = 0;
      state.timer = setInterval(() => state.processingTime++, 1000);
      context.root.$nextTick(() => {
        modalCorrectImageRef.value.show();
      });

      context.root.$nextTick(() => {
        if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
          // 採点済みデータありの場合は○×順表示で表示
          changeSortKind(state.SortKindEnum.CorrectState);
        }else{
          // 全件未採点の場合は番号順で表示
          changeSortKind(state.SortKindEnum.No);
        }
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      state.isShortcutKeyEnable = true;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 切り出し画像Base64文字列をセット
     ************************************************************/

    const setBase64Image = (idx: number, base64Image: string) => {
      state.fieldActivities[idx].base64Image = base64Image;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ追加
     ************************************************************/

    const addScoreStamp = (point: Point, score: number) => {
      state.fieldActivities[state.selectedIdx].scoreStamps.forEach(x => x.isActive = false);

      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = state.fieldActivities[state.selectedIdx].scoreStampIdx++;
      scoreStamp.x = point.x;
      scoreStamp.y = point.y;
      scoreStamp.height = 50;
      scoreStamp.width = `${score}`.length * scoreStamp.height / 2;
      scoreStamp.score = score;
      scoreStamp.color = "red";
      scoreStamp.isActive = true;
      state.fieldActivities[state.selectedIdx].scoreStamps.push(scoreStamp);

      // ベースとなる点数を取得 加点方式の場合は0点スタート、減点方式の場合は配点からスタート
      const baesScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 0 : state.currentSheetField.allot;
      let sumScore = Common.sumArray(state.fieldActivities[state.selectedIdx].scoreStamps.map(x => x.score)) + baesScore;
      // 0点を下限、配点を上限とする
      if(sumScore < 0){
        sumScore = 0;
      }else if(sumScore > state.currentSheetField.allot){
        sumScore = state.currentSheetField.allot;
      }

      let correct_state = null;

      if(sumScore == state.currentSheetField.allot){
        correct_state = CorrectStateEnum.Seitou;
      }else if(sumScore == 0){
        correct_state = CorrectStateEnum.Gotou;
      }else{
        correct_state = CorrectStateEnum.Tokuten;
      }
      
      state.fieldActivities[state.selectedIdx].score = sumScore;
      state.fieldActivities[state.selectedIdx].correct_state = correct_state;

      state.isShowContextMenu = false;
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteScoreStamp = (fieldActivityIdx: number, scoreStampIdx: number) => {
      state.fieldActivities[fieldActivityIdx].scoreStamps.splice(scoreStampIdx, 1);
      
      if(state.fieldActivities[fieldActivityIdx].scoreStamps.length == 0){
        // 削除した結果スタンプが0件になった場合、未採点に戻る
        state.fieldActivities[fieldActivityIdx].score = null;
        state.fieldActivities[fieldActivityIdx].correct_state = null;
      }else{
        // ベースとなる点数を取得 加点方式の場合は0点スタート、減点方式の場合は配点からスタート
        const baesScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 0 : state.currentSheetField.allot;

        let score = Common.sumArray(state.fieldActivities[fieldActivityIdx].scoreStamps.map(x => x.score)) + baesScore;
        // 0点を下限、配点を上限とする
        if(score < 0){
          score = 0;
        }else if(score > state.currentSheetField.allot){
          score = state.currentSheetField.allot;
        }

        let correct_state = null;

        if(score == state.currentSheetField.allot){
          correct_state = CorrectStateEnum.Seitou;
        }else if(score == 0){
          if(state.fieldActivities[state.selectedIdx].scoreStamps.length == 0){
            // 削除した結果スタンプ0件になった場合、未採点になる
            correct_state = null;
            score = null;
          }else{
            correct_state = CorrectStateEnum.Gotou;
          }
          correct_state = CorrectStateEnum.Gotou;
        }else{
          correct_state = CorrectStateEnum.Tokuten;
        }

        state.fieldActivities[fieldActivityIdx].score = score;
        state.fieldActivities[fieldActivityIdx].correct_state = correct_state;
      }
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      initialize();
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }
      
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("resize", adjustLayout);
      if(state.allowResetSaitenLock){
        await http.post(`/api/saiten_input_score_stamp/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    return {
      ...toRefs(state),
      saitenBoxRef,
      modalCorrectImageRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      modalPreviewImageRef,
      carouselRef,
      setBase64Image,
      showPreviewImage,
      changeSaitenMode,
      changeSortKind,
      clearCorrect,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      keyUp,
      showModalCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      base64PreviewImages,
      carouselPrev,
      carouselNext,
      changePrevModalStudent,
      changeNextModalStudent,
      changeSelectedIdx,
      scaleUp,
      scaleDown,
      fitToImageArea,
      selectedIdxUp,
      selectedIdxDown,
      updateCorrectState,
      addScoreStamp,
      deleteScoreStamp,
      showContextMenu,
      hideContextMenu,
      contextAreaStyle,
      contextButtonStyle,
      keyDown,
      changeSaitenModeBySaitenBox,
      contextMenuMouseDown,
      scale,
      fieldImageWidth,
      fieldWrapWidth,
      fieldImageHeight,
      fieldWrapHeight,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
    };
  }
});
